import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import MailOutline from "@material-ui/icons/MailOutline";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { GetTopUpMethodDescription } from "enums/TopUpMethod";
import { creditMonitoringApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function Delete(props) {
  const source = useRef(new AbortController());
  const { id } = useParams();

  useEffect(() => {
    return () => source.current.abort();
  }, []);

  const [topUpLimitConfiguration, setTopUpLimitConfiguration] = React.useState(
    null
  );
  const [redirect, setRedirect] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);

  useEffect(() => {
    creditMonitoringApi
      .get("/TopUpLimitConfigurations/" + id, {
        signal: source.current.signal
      })
      .then(data => setTopUpLimitConfiguration(data))
      .catch(error => console.log(error));
  }, [id]);

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    creditMonitoringApi
      .delete("/TopUpLimitConfigurations/" + id, {
        signal: source.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();

  return redirect ? (
    <Redirect to="/admin/TopUpLimitConfigurations/List" />
  ) : (
    topUpLimitConfiguration !== null && (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                Delete Top Up Limit Configuration
              </h4>
            </CardHeader>
            <CardBody>
              <i>*Are you sure to delete this Top Up Limit Configuration?</i>
              <form onSubmit={handleSubmit}>
                <Button onClick={() => props.history.goBack()} value="Cancel">
                  CANCEL
                </Button>
                <Button disabled={disabled} color="rose" type="submit">
                  DELETE
                </Button>
              </form>
              <CustomInput
                labelText="Method"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  disabled: true,
                  value: GetTopUpMethodDescription(
                    topUpLimitConfiguration.method
                  )
                }}
              />
              <CustomInput
                labelText="Currency"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  disabled: true,
                  value: topUpLimitConfiguration.currency
                    ? topUpLimitConfiguration.currency.code
                    : ""
                }}
              />
              <CustomInput
                labelText="Minimum Limit"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  disabled: true,
                  value: topUpLimitConfiguration.hasMinimumLimit
                    ? topUpLimitConfiguration.minimumLimit
                    : "Disabled"
                }}
              />
              <CustomInput
                labelText="Maximum Limit"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  disabled: true,
                  value: topUpLimitConfiguration.hasMaximumLimit
                    ? topUpLimitConfiguration.maximumLimit
                    : "Disabled"
                }}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  );
}

Delete.propTypes = {
  history: PropTypes.object
};
